import apiClient from "../apiClient";

let ControllerName = 'helpers';
const HelpersControllers = Object.freeze({
    countries: `${ControllerName}/countries`,
    categories: `${ControllerName}/categories`,
    teachers: `${ControllerName}/teachers`,
    global: `${ControllerName}/global`
});

/**
 * Fetches a list of all countries.
 * @returns {Promise<Object>} - Returns the data from the API response if successful.
 * @throws {Error} - Alerts the user with the error message if the request fails.

export const getAllCountries = async () => {
    try {
        const response = await apiClient.get(`${HelpersControllers.countries}`);
        return response.data
    } catch (error) {
        alert(error.message)
    }
}
*/
/**
 * Fetches a list of all teachers.
 * @returns {Promise<Object>} - Returns the data from the API response if successful.
 * @throws {Error} - Alerts the user with the error message if the request fails.
 */
export const getTeachers = async () => {
    try {
        const response = await apiClient.get(`${HelpersControllers.teachers}`);
        return response.data
    } catch (error) {
        console.log(error.message)
    }
}


/**
 * Fetches a list of all categories.
 * @returns {Promise<Object>} - Returns the data from the API response if successful.
 * @throws {Error} - Alerts the user with the error message if the request fails.
 */
export const getCategories = async () => {
    try {
        const response = await apiClient.get(`${HelpersControllers.categories}`);
        return response.data
    } catch (error) {
        console.log(error.message)
    }
}

/**
 * Fetches a list of all categories.
 * @returns {Promise<Object>} - Returns the data from the API response if successful.
 * @throws {Error} - Alerts the user with the error message if the request fails.
 */
export const getData = async () => {
    try {
        const response = await apiClient.get(`${HelpersControllers.global}`);
        return response.data
    } catch (error) {
        console.log(error.message)
    }
}


/**
 * Fetches a list of all categories.
 * @returns {Promise<Object>} - Returns the data from the API response if successful.
 * @throws {Error} - Alerts the user with the error message if the request fails.
 */
export const getFaq = async () => {
    try {
        const response = await apiClient.get('/frequently-questions');
        return response.data
    } catch (error) {
        console.log(error.message)
    }
}